import { Component, HostListener, ChangeDetectorRef, inject, DestroyRef, ViewChild, ElementRef, Pipe, PipeTransform, Inject, forwardRef } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { TableColumn } from 'src/app/models/TableColumn';
import { CustomerService } from 'src/app/services/customer.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { CustomerFormComponent } from '../customer-form/customer-form.component';
import { TableControlComponent, TButtonAction, TOnLoadPage } from 'src/app/shared/controls/table-control/table-control.component';
import { AssignPlanComponent } from 'src/app/modules/customer-plans/assign-plan/assign-plan.component';
import { ListCustomerPlansComponent } from 'src/app/modules/customer-plans/list-customer-plans/list-customer-plans.component';
import { DeviceFormComponent } from 'src/app/modules/devices/device-form/device-form.component';
import { FormsModule } from '@angular/forms';
import { DropdownControlComponent } from 'src/app/shared/controls/dropdown-control/dropdown-control.component';
import { DropdownItem } from 'src/app/shared/controls/dropdown-control/dropdown-control.component';
import { InventoryService } from 'src/app/services/inventory.service';
import { PlanAvailableDTO } from 'src/app/models/PlanAvailableDTO.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { UnassignedCustomerDeviceDto } from 'src/app/models/UnassignedCustomerDeviceDto';
import { PlanDeviceDTO } from 'src/app/models/PlanDeviceDTO.model';
import { AssignUsersComponent } from '../../customer-users/assign-users/assign-users.component';
import { ListCustomerUsersComponent } from '../../customer-users/list-customer-users/list-customer-users.component';
import { DialogService } from '../../../services/dialog.service';
import { firstValueFrom, Observable } from 'rxjs';
import { GetCustomerDevicesResultDTO } from '../../../models/GetCustomerDevicesResultDTO';
import { renderDeviceStatus, StatusSimDTO } from '../../../models/StatusSimDTO.model';
import { TDeviceUsageDTO } from '../../../models/TDeviceUsageDTO.model';
import { ConsumptionViewComponent } from '../../plan-devices/consumption-view/consumption-view.component';
import { PlanDeviceSummaryDTO } from '../../../models/PlanDeviceSummaryDTO.model';
import { SimpleRequestLongList } from '../../../shared/models/SimpleRequestLongList';
import { ResponseDataFile } from '../../../shared/models/ApiResponse';
import { AddDeviceService } from '../../../services/add-device.service';
import saveAs from 'file-saver';
import { AuditDataDTO, AuditService, LoadAuditDataRequestDTO } from '../../../services/audit.service';
import { PageArray } from '../../../models/ApiResponse';
import { LoadNotesRequestDTO, NoteDTO, NotesService, NoteType, noteTypeText, NoteVisibility, noteVisiblilityText } from '../../../services/notes.service';
declare var bootstrap: any;

declare type TCustomerPlanItem = (DropdownItem<number, PlanAvailableDTO> & { usageData?: TDeviceUsageDTO, devices?: PlanDeviceSummaryDTO[] });

@Pipe({ name: 'plansForTransfer', pure: false })
class PlansForTransferPipe implements PipeTransform {

    static filter(items?: DropdownItem<number>[], currentItem?: GetCustomerDevicesResultDTO): DropdownItem<number>[] {
        return items?.filter(x => currentItem?.status === 2 || x.key !== currentItem?.userPlanId) || [];
    }

    constructor(@Inject(forwardRef(() => CustomerAccountComponent)) private host: CustomerAccountComponent) { }

    transform<T>(items: DropdownItem<number>[]): DropdownItem<number>[] {
        return PlansForTransferPipe.filter(items, this.host.assignTransferAction?.item);
    }
}



@Component({
    selector: 'app-customer-account',
    templateUrl: './customer-account.component.html',
    styleUrls: ['./customer-account.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        CustomerFormComponent,
        TableControlComponent,
        AssignPlanComponent,
        ListCustomerPlansComponent,

        DeviceFormComponent, DropdownControlComponent,
        AssignUsersComponent, ListCustomerUsersComponent,
        ConsumptionViewComponent,

        PlansForTransferPipe
    ]
})
export class CustomerAccountComponent {

    private changeDetector = inject(ChangeDetectorRef);
    private customerService = inject(CustomerService);
    public permissionsService = inject(ValidatePermissionsService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    public location = inject(Location);
    private inventoryService = inject(InventoryService);
    private alertService = inject(AlertService);
    public dialog = inject(DialogService);
    private addDeviceService = inject(AddDeviceService);
    private auditService = inject(AuditService);
    private notesService = inject(NotesService);

    customerId?: number;

    public customer: UserDTO = {} as UserDTO;
    public information: string = '';


    ngOnInit() {
        // Уже не нужно вызывать this.permissionsService.validateAccessLevels(MODULE_ID); при инициализации модуля, т.к. это делается автоматически в AuthorizationGuard
        //this.permissionsService.validateAccessLevels(MODULE_ID.Customers);
        this.customerId = +this.route.snapshot.paramMap.get('id')!;
        this.currentTab = this.route.snapshot.queryParamMap.get('tab') || this.currentTab;
        this.information = `Customer ID/Account: ${this.customerId}`;
        this.checkFieldsFilter();
    }

    onUserLoaded(user: UserDTO) {
        this.customer = user;
        this.setupTabEventListeners();
        this.loadCustomerPlans();
    }

    //#region - Tabs -

    public currentTab: string = 'sims';

    private setupTabEventListeners(): void {
        const tabElements = document.querySelectorAll('button[data-bs-toggle="tab"]');
        tabElements.forEach(tabElement => {
            tabElement.addEventListener('shown.bs.tab', (event: Event) => {
                const target = event.target as HTMLElement;
                const tabId = target.getAttribute('data-bs-target');
                this.onTabActivated(tabId);
            });
        });
        this.onTabActivated(this.currentTab || 'sims');
    }

    private onTabActivated(tabId: string | null): void {
        tabId = tabId || '';
        if (tabId?.startsWith('#') === true) tabId = tabId.substring(1);
        if (tabId?.endsWith('-tab') === true) tabId = tabId.substring(0, tabId.length - 4);
        this.currentTab = tabId;

        const url = this.router.createUrlTree([], {
            queryParams: { tab: this.currentTab === 'sims' ? undefined : this.currentTab },
            queryParamsHandling: 'merge'
        }).toString();
        this.location.replaceState(url);

        switch (tabId) {
            case 'sims':
                // Логика для таба SIMs
                this.loadSims();
                break;
            case 'plans':
                // Логика для таба Plans
                break;
            case 'tickets':
                // Логика для таба Tickets
                break;
            case 'notes':
                // Логика для таба Notes
                this.loadNotes();
                break;
            case 'reports':
                // Логика для таба Reports
                break;
            case 'users':
                // Логика для таба Users
                break;
            case 'billing':
                // Логика для таба Billing
                break;
            case 'history':
                // Логика для таба History
                this.loadAuditData();
                break;
        }
    }

    //#endregion - Tabs -


    //#region - SIMs -

    public sims: GetCustomerDevicesResultDTO[] = [];
    public assignTransferAction?: any;
    public remainUsageData: boolean = false;

    public simsColumns: TableColumn[] = [
        { key: 'carrier', header: 'Carrier', },  
        {
            key: 'consumption', header: 'Usage in MB',
            render: (value: any, row?: GetCustomerDevicesResultDTO) => {
                this.loadConsumptions(row);
                return value;
            },
            format: {
                type: 'number',
                decimalPlaces: 2,
                customFormatter: (value: any) => {
                    return value === ''
                        ? '...'
                        : value
                            ? `${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 })} MB`
                            : 'N/A';
                }
            }
        },
        {
            key: 'iccid', header: 'ICCID', render: (value: any, row?: any) =>
                this.permissionsService.inventory.editPermission
                    ? `<a href="/inventory/inventory-update/${value}">${value}</a>`
                    : value
        },
        { key: 'imei', header: 'IMEI', },                                       
        //{ key: 'status', header: 'Status', cellClass: 'text-center', nonFiltered: true,  render: (value: any, row?: any) => `<span class="badge bg-${value == 1 ? 'success' : 'warning'}-subtle text-${value == 1 ? 'success' : 'warning'}-emphasis">${value==1 ? 'Active' : 'Suspended'}</span>` },
        { key: 'deviceStatusName', header: 'Status', cellClass: 'text-center', nonFiltered: false, render: (value, row) => renderDeviceStatus(value, row) },
        {
            key: 'planName', header: 'Plan', render: (value: any, row?: any) =>
                this.permissionsService.plans.editPermission
                    ? `<a href="/customers/view-customer/${this.customerId}/${row.userPlanId}">${value}</a>`
                    : value
        },
        { key: 'linkworxActivationDate', header: 'Activation Date', nonFiltered: true, format: { type: 'date', dateFormat: 'MM-dd-yyyy' } },
        { key: 'deactivationDate', header: 'Deactivation Date', nonFiltered: true, format: { type: 'date', dateFormat: 'MM-dd-yyyy', } },
        { key: 'suspensionDate', header: 'Suspension Date', nonFiltered: true, format: { type: 'date', dateFormat: 'MM-dd-yyyy', } },
        { key: 'userName', header: 'User Name', maxWidth: 200, hidden: false },
        { key: 'originatedFrom', header: 'Originated From', },
        /*
        { key: 'primary', header: 'Primary', },
        { key: 'modemType', header: 'Modem Type', },
        { key: 'serialNumber', header: 'Serial Number', },
        { key: 'ipAddress', header: 'IP', },
        { key: 'userName2', header: 'User Name 2', width: 200, },
        { key: 'custom1', header: 'Custom Field 1', width: 200, },
        { key: 'custom2', header: 'Custom Field 2', width: 200, },
        { key: 'firstName', header: 'First Name', width: 200, },
        { key: 'lastName', header: 'Last Name', width: 200, },
        { key: 'mdn', header: 'MDN', },
        */
    ];

    public simsActionButtons: TButtonAction[] = [
        {
            label: 'dataTransfer', tooltip: 'Device Transfer', class: 'primary', icon: 'bi bi-arrow-right-circle',
            disabled: (item: GetCustomerDevicesResultDTO) => item.status === 2,
            hidden: (item: GetCustomerDevicesResultDTO) => item.status === 2 || !this.permissionsService.isAdmin
        },
        {
            label: 'revertTransfer', tooltip: 'Revert Transfer', class: 'danger', icon: 'bi bi-arrow-counterclockwise',
            disabled: (item: GetCustomerDevicesResultDTO) => item.status === 2,
            hidden: (item: GetCustomerDevicesResultDTO) => item.status === 2 || !this.permissionsService.isAdmin
        },
    ];

    public getRawClass(item: GetCustomerDevicesResultDTO) {
        if (item.status === 2) {
            return 'raw-unassigned';
        }
        return undefined;
    }

    public async onSimsAction(e: { action: string; item: GetCustomerDevicesResultDTO }, extra?: boolean) {
        switch (e.action) {
            // переключение SIM-карты на другой клиентский план
            case 'dataTransfer':
                if (!extra) {
                    this.assignTransferAction = e;
                    const list = PlansForTransferPipe.filter(this.customerPlans, e.item);
                    if (list.length === 1) {
                        this.customerPlanSelected = list[0].key;
                    } else {
                        this.customerPlanSelected = undefined;
                    }
                    await this.dialog.open('modalAssignDeviceTransfer');
                } else {
                    if (this.customerPlanSelected) {
                        if (e.item.status === 2) {
                            // assign new customer plan anyway
                            try {
                                await this.updatePlanDevices(e.item, +this.customerPlanSelected);
                                this.loadSims();
                                this.alertService.success('Devices transfer assigned successfully.');
                            } catch (e) {
                                this.alertService.error('Error when devices transfer assigned.');
                            } 
                        }
                        else {
                            if (e.item.userPlanId !== this.customerPlanSelected) {
                                if (!this.remainUsageData) {
                                    // rollback previous
                                    await this.revertDeviceTransferFromUserPlan(e.item);
                                }
                                // assign new customer plan
                                await this.updatePlanDevices(e.item, +this.customerPlanSelected);
                                this.loadSims();
                                this.alertService.success('Devices transfer reassigned successfully.');
                            } else {
                                // impossible code path
                            }
                        }
                    }
                }
                break;
            // Возврат SIM-карты на предыдущий клиентский-план
            // данные об использовании будут также перенесены 
            case 'revertTransfer':
                const ok = await this.dialog.show(
                    `You are about to roll back the transfer of the device <b>${e.item.iccid}</b>.<br/>Are you sure?`,
                    'Revert Device Transfer',
                    ['Yes, Continue', 'Cancel']);
                if (ok) {
                    try {
                        // ToDo: проверить!!!!
                        var sm = this.sims.filter(s => s.iccid === e.item.iccid && s.status === 2)
                            .sort((x1, x2) => x1.userPlanId === x2.userPlanId
                                              ? 0
                                              : ((x1.userPlanId ?? 0) < (x2.userPlanId ?? 0) ? 1 : -1));
                        const oldUserPlanId = sm.length > 0 ? sm[0].userPlanId : null;
                        //const oldUserPlanId = null;
                        if (oldUserPlanId) {
                            // assign new customer plan
                            await this.updatePlanDevices(e.item, +oldUserPlanId);
                        } else {
                            await this.revertDeviceTransferFromUserPlan(e.item);
                        }
                        this.loadSims();
                        this.alertService.success('Devices transfer rollback successfully.');
                    } catch (e) {
                        this.alertService.error('Error when devices transfer rollback.');
                    } 
                }
                break;
        }
    }

    revertDeviceTransferFromUserPlan(item: GetCustomerDevicesResultDTO): Promise<void> {
        return <any>firstValueFrom(this.inventoryService.revertDedviceTransferFromUserPlan(<any>
            {
                devices: [item.iccid],
                userPlanId: item.userPlanId
            }));
    }

    updatePlanDevices(item: GetCustomerDevicesResultDTO, userPlanId: number) {
        // return <any>firstValueFrom(this.inventoryService.updatePlanDevices([
        return this.inventoryService.updatePlanDevicesAsync([
            {
                aDeviceId: item.deviceId,
                aUserPlanId: userPlanId
            }
        ]);
    }

    loadSims() {
        this.customerService.getCustomerDevices(this.customerId!)
            .subscribe({
                next: response => {
                    //console.log(response);
                    this.sims = response.sort((a, b) => a.deviceId! - b.deviceId!);
                },
                error: e => console.error('Error when loading customer plans:', e)
            });        
    }

    loadConsumptions(item: GetCustomerDevicesResultDTO | any) {
        if (item.consumption === undefined) {
            item.consumption = '';
            if (item.userPlanId) {
                this.customerService.getDeviceConsumptions(item.planDevId).subscribe({
                        next: data => {
                            item.consumption = data;
                        },
                        error: e => {
                            item.consumption = e;
                        }
                    }
                );
            }
        }

    }

    customerPlanSelected?: number;
    customerPlans: TCustomerPlanItem[] = null!;

    loadCustomerPlans() {
        this.inventoryService.getListPlansAvailables(this.customerId).subscribe(
            {
                next: (response: PlanAvailableDTO[]) => {
                    this.customerPlans = response.map(plan => ({
                        key: plan.userPlanId,
                        value: plan.namePlan,
                        source: plan
                    }));
                    if (this.customerPlans.length === 1) {
                        this.customerPlanSelected = this.customerPlans[0].key;
                    }
                    // загрузка помесячного использования каждого из планов в за последние 12 месяцев
                    for (let userPlan of this.customerPlans) {

                        this.customerService.getCustomerPlanByUserPlanId(userPlan.key).subscribe({
                            next: (data: PlanDeviceSummaryDTO[]) => {
                                userPlan.devices = data;
                            },
                            error: (error) => {
                                // Handle error if needed
                            }
                        });


                        this.customerService.getAllUsagesByUserPlanId(userPlan.key).subscribe({
                            next: (data: TDeviceUsageDTO) => {
                                userPlan.usageData = data;
                            },
                            error: (error) => {
                                // Handle error if needed
                            }
                        });
                    }
                },
                error: error => console.error('Load Customer Plans Error:', error)
            });
    }

    public onAddSim(iccid?: string) {
        if (!iccid) {
            // the button Add Sim pressed
            this.dialog.open('modalAddSim');
        } else {
            // A SIM was added
            this.dialog.closeModal();
            if (this.customerPlanSelected) {
                // Adding the SIM to a Customer Plan
                const request: PlanDeviceDTO[] = [
                    {
                        aUserPlanId: this.customerPlanSelected,
                        iccid1: iccid
                    }
                ];
                this.inventoryService.updatePlanDevicesAsync(request).subscribe(
                    {
                        next: data => {
                            this.loadSims();
                            this.alertService.success('The device has been successfully assigned to the customer\'s plan.');
                        },
                        error: error => this.alertService.error('An error occurred when assigning the device to the customer\'s plan.')
                    });
            }
        }
    }

    //#endregion - SIMs -


    //#region - Reports -

    //public fromDate?: string = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    //public toDate?: string = new Date().toISOString().split('T')[0];
    public fromDate?: string = Temporal.Now.plainDateISO().with({ day: 1 }).subtract({ months: 11 }).toString();
    public toDate?: string = Temporal.Now.plainDateISO().toString();
    public fieldsCompletedFilter: boolean = false;

    checkFieldsFilter() {
        if (this.fromDate && this.toDate) {
            if (new Date(this.fromDate) >= new Date(this.toDate)) {
                this.toDate = "";
                this.fieldsCompletedFilter = false;
            }
            else {
                this.fieldsCompletedFilter = true;
            }
        }
        else {
            this.fieldsCompletedFilter = false;
        }
    }

    minDate(): string | null {
        if (this.fromDate) {
            const minDate = new Date(this.fromDate);
            minDate.setDate(minDate.getDate() + 1);
            return minDate.toISOString().split('T')[0];
        }
        return null;
    }

    private handleDownloadDevice(data: ResponseDataFile) {
        const byteCharacters = atob(data.Data.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: data.Data.contentType });
        saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    }

    private handleGetFileErrorDevice() {
        /*
        this.alertService.updateAlertState({
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
        });
        */
    }

    private createRequest(plan: TCustomerPlanItem | null, consolidated: boolean, fromDate?: string, toDate?: string) {
        const request = {} as SimpleRequestLongList;
        request.id = plan?.key;
        request.customerId = this.customerId;
        //request.listIds = plan?.devices?.map(device => device.aPlanDeviceId) ?? [];
        //request.listIds = plan?.devices?.select(device => device.aPlanDeviceId).toArray() ?? [];
        request.consolidated = consolidated;
        request.fromDate = fromDate !== undefined ? new Date(fromDate) : undefined;
        request.toDate = toDate !== undefined ? new Date(toDate) : undefined;

        return request;
    }

    private executeRequest(svc: Observable<ResponseDataFile>) {
        svc.subscribe({
            next: (response: ResponseDataFile) => {
                if (response) {
                    this.handleDownloadDevice(response);
                } else {
                    this.handleGetFileErrorDevice();
                }
            },
            error: e => {
                console.error('Error exporting the Excel file:', e);
            }
        });
    }

    public exportToExcelListPlanDevicesConsolidated(plan: TCustomerPlanItem) {
        this.executeRequest(this.addDeviceService.exportToExcelListPlanDevicesConsolidated(this.createRequest(plan, true)));
    }

    public exportToExcelListPlanDevices(plan: TCustomerPlanItem) {
        this.executeRequest(this.addDeviceService.exportToExcelListPlanDevices(this.createRequest(plan, false)));
    }

    public async exportToExcelListPlanDevicesHistoricConsolidated(plan: TCustomerPlanItem) {
        if (!(await this.dialog.open('modalSelectReportPeriod'))) return;
        this.executeRequest(this.addDeviceService.exportToExcelListPlanDevicesAnnual(this.createRequest(plan, true, this.fromDate, this.toDate)));
    }

    public async exportToExcelListPlanDevicesHistoric(plan: TCustomerPlanItem) {
        if (!(await this.dialog.open('modalSelectReportPeriod'))) return;
        this.executeRequest(this.addDeviceService.exportToExcelListPlanDevicesAnnual(this.createRequest(plan, false, this.fromDate, this.toDate)));
    }

    public async exportToExcelAllUsage() {
        if (!(await this.dialog.open('modalSelectReportPeriod'))) return;
        const req = this.createRequest(null, true, this.fromDate, this.toDate);
        this.executeRequest(this.addDeviceService.exportToExcelListPlanDevicesAnnual(req));
    }

    //#endregion - Reports -


    //#region - History -

    public auditColumns: TableColumn[] = [
        { key: 'date', header: 'Date & Time (UTC)' },
        { key: 'eventType', header: 'Event Type' },
        { key: 'user', header: 'Performed By', },
        { key: 'details', header: 'Details', },
    ];

    public loadAuditReq: LoadAuditDataRequestDTO = null!;

    loadAuditData() {
        this.loadAuditReq = {
            customerId: this.customerId!,
        };
    }

    async onLoadAudit(e: TOnLoadPage) {
        try {
            const res = await this.auditService.loadAuditDataAsync(e.req);
            e.setData(res);
        } catch (error) {
            e.setData(error);
        } 
    }

    //#endregion - History -



    //#region - Notes -

    public notesColumns: TableColumn[] = [
        { key: 'dateCreated', header: 'Date & Time (UTC)', width: 1, format: { type: 'date', dateFormat: 'MM-dd-yyyy hh:mm:ss a', } },
        { key: 'userName', header: 'Created By', width: 1, sortable: false },
        { key: 'visibility', header: 'Visibility', width: 1, sortable: false, format: { customFormatter: v => noteVisiblilityText(v) } },
        { key: 'noteType', header: 'Note Type', width: 1, sortable: false, format: { customFormatter: v => noteTypeText(v) } },
        { key: 'noteText', header: 'Note', sortable: false, tooltip: v => v },
    ];

    public notesActionButtons: TButtonAction[] = [
        {
            label: 'viewNote', tooltip: 'View Note', class: 'primary', icon: 'bi bi-eye',
        }
    ];

    public loadNotesReq: LoadNotesRequestDTO = null!;

    loadNotes() {
        this.loadNotesReq = {
            customerId: this.customerId!,
        };
    }

    async onLoadNotes(e: TOnLoadPage) {
        try {
            const res = await this.notesService.loadAsync(e.req);
            e.setData(res);
        } catch (error) {
            e.setData(error);
        } 
    }

    public noteTypes = [
        { id: NoteType.General, name: 'General' },
        { id: NoteType.Call, name: 'Call' },
        { id: NoteType.Billing, name: 'Billing' },
        { id: NoteType.TechSupport, name: 'Tech Support' },
    ];
    public noteType: NoteType = NoteType.General;

    public noteVisibilities = [
        { id: NoteVisibility.Internal, name: 'INTERNAL' },
        { id: NoteVisibility.External, name: 'External' },
    ];
    public noteVisibility: NoteVisibility = NoteVisibility.Internal;

    public noteText: string = '';
    public noteDialogMode: 'create' | 'view' = 'create';

    async addNote() {
        this.noteText = '';
        this.noteDialogMode = 'create';
        if (!(await this.dialog.open('modalCreateNote')) || this.noteText === '') return;
        const note = <NoteDTO>{
            customerId: this.customerId,
            noteType: +this.noteType,
            visibility: +this.noteVisibility,
            noteText: this.noteText 
        }
        await this.notesService.createAsync(note);
        this.loadNotes();
    }

    public async onNotesAction(e: { action: string; item: NoteDTO }) {
        switch (e.action) {
            // показать диалог для просмотра текущего примечания
            case 'viewNote':
                this.noteDialogMode = 'view';
                this.noteType = e.item.noteType ?? 0;
                this.noteVisibility = e.item.visibility;
                this.noteText = e.item.noteText;
                if (!(await this.dialog.open('modalCreateNote')) || this.noteText === '') return;
                break;
        }
    }


    //#endregion - Notes -

}
